import { loadLocale } from './loadLocale';

export interface TranslateReplaceItem {
  key: string;
  value: string;
  translateReplace?: boolean;
}

interface TranslationKeys {
  [key: string]: string;
}

let messages: TranslationKeys = {};
// hardcoded because EN is only available for now
loadLocale('en')
  .then((data) => {
    messages = data;
  })
  .catch((error) => console.error(error));

// Function to get translations from Phrase
export const t = (
  key: string | undefined,
  placeholderArray: TranslateReplaceItem[] = []
): string => {
  if (!key) return 'Missing key!';
  let translation = messages[key];
  if (key === translation || !translation) return `Missing key > ${key}`;

  if (placeholderArray.length) {
    placeholderArray.forEach((replaces) => {
      if (replaces instanceof Array) {
        replaces.forEach((itemToReplace) => {
          if (itemToReplace?.key) {
            let replaceValue = itemToReplace.value || '';
            if (itemToReplace.translateReplace && itemToReplace.translateReplace === true) {
              replaceValue = t(itemToReplace.value);
            }
            replaceValue = (replaceValue || '').toString();
            translation = translation.replace(new RegExp(`%${replaces.key}%`, 'g'), replaceValue);
          }
        });
      } else {
        if (replaces?.key) {
          let replaceValue = replaces.value ?? '';
          if (replaces.translateReplace) {
            replaceValue = t(replaces.value);
          }
          replaceValue = (replaceValue || '').toString();
          translation = translation.replace(new RegExp(`%${replaces.key}%`, 'g'), replaceValue);
        }
      }
    });
  }

  return translation;
};
